import '../../App.css';
import { useEffect } from 'react';
import React, { useState, useRef } from "react";
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import YouTubePlayer from '../../components/VideoPlayer/videoPlayer';
import "./UNOR4.css";
import {useNavigate} from "react-router-dom";

const UNOR3 = () => {
    
    const [showFinalImage, setShowFinalImage] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animationFinished, setAnimationFinished] = useState(false);



    const navigate = useNavigate()

    const handleComprar = () => {
        navigate("/products/22-Arduino%20UNO%20R3")
    }

    const images = [
        "/images/UNOR3/One.png",
        "/images/UNOR3/Two.png",
        "/images/UNOR3/Three.png",
        "/images/UNOR3/Four.png",
        "/images/UNOR3/Five.png",
        "/images/UNOR3/Six.png",
    ];
    useEffect(() => {
        if (currentIndex < images.length) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => prevIndex + 1);
            }, 150);

            return () => clearInterval(interval);
        } else {
            setAnimationFinished(true);
        }
    }, [currentIndex, images.length]);

    return (
        <div>
            <Header/>
            <div className="image-rotation-container">
                <img
                    src={images[Math.min(currentIndex, images.length - 1)]}
                    alt="Rotating Animation Frame"
                    className="animation-image"
                />
                <h1 className="title">{animationFinished ? "UNO R3" : "\u00A0"}</h1>
                <h2> {animationFinished ? "La placa de microcontrolador más popular" : "\u00A0"} </h2>
                {animationFinished ? <button className="order-btn" onClick={handleComprar}> Compra Ahora</button> : "\u00A0"}
                <br/>

            </div>
            <div className="ESP-info-container">
                <div className="ESP-content">
                    <div className="R3-image-container">
                        <img src={'/images/UNOR3/One.png'} alt="Microcontrolador ESP32" className="R3-image"/>
                        <div className="ESP-dots-overlay"></div>
                    </div>
                    <div className="ESP-text-container">
                        <div className="ESP-text ESP-text-1">
                            Microcontrolador Extraible
                        </div>
                        <div className="ESP-text ESP-text-2">
                            USB tipo B
                        </div>
                        <div className="ESP-text ESP-text-3">
                            Soporte completo en Arduino IDE
                        </div>
                        <div className="ESP-text ESP-text-4">
                            Ideal para proyectos sencillos
                        </div>

                        <div className="ESP-text ESP-text-5">
                            Alimentación por Barrell Jack
                        </div>
                    </div>
                </div>
            </div>
            <div className="technical-specs-container">
                <div className="technical-specs-box">
                    <div>
                        <h2 className="technical-specs-title">Especificaciones técnicas:</h2>
                        <ul className="technical-specs-list">
                            <li>Microcontrolador ATMega328P (extraible)</li>
                            <li>USB B</li>
                            <li>Memoria Flash 32kB</li>
                            <li>SRAM 2kB</li>
                            <li>14 pines Digitales (6PWM)</li>
                        </ul>
                    </div>
                </div>
                <img
                    src="/images/R3Caja.jpg"
                    alt="Descripción de la imagen"
                    className="technical-specs-image"
                />
            </div>


            <div className="ESP-info-container">
                <h1 className="ESP-title">
                    La opción ideal para iniciar
                </h1>
            </div>
            <div className="image-rotation-container">

                <button className="order-btn" onClick={handleComprar}> Compra Ahora</button>

            </div>
            <Footer/>
        </div>
    );
};

export default UNOR3;